import React, { useMemo } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import { activityStatusesDataSource } from 'infrastructure/data-sources/activity-statuses';
import { ActivityStatus } from 'infrastructure/enums';

import type { IActivityStatusItem } from 'infrastructure/data-sources/activity-statuses';
import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';

type Options = IBaseSelectBoxOption<
  IActivityStatusItem['id'],
  IActivityStatusItem
>[];

interface IProps extends Omit<IBaseSelectBoxProps<ActivityStatus>, 'options'> {
  type?: ActivityStatus;
}

const ActivityStatusSelectBox: React.FC<IProps> = (props) => {
  const { type } = props;
  const dataSource = useMemo(() => {
    const items = activityStatusesDataSource();
    if (type === ActivityStatus.Actioned) {
      return items.filter(
        (el) =>
          el.id !== ActivityStatus.Unactioned &&
          el.id !== ActivityStatus.UnactionedNormalRisk &&
          el.id !== ActivityStatus.UnactionedCritical,
      );
    }
    if (type === ActivityStatus.Unactioned) {
      return items.filter(
        (el) =>
          el.id !== ActivityStatus.Actioned &&
          el.id !== ActivityStatus.UnactionedNormalRisk &&
          el.id !== ActivityStatus.UnactionedCritical,
      );
    }
    if (type === ActivityStatus.UnactionedNormalRisk) {
      return items.filter(
        (el) =>
          el.id !== ActivityStatus.Actioned &&
          el.id !== ActivityStatus.Unactioned &&
          el.id !== ActivityStatus.UnactionedCritical,
      );
    }
    if (type === ActivityStatus.UnactionedCritical) {
      return items.filter(
        (el) =>
          el.id !== ActivityStatus.Actioned &&
          el.id !== ActivityStatus.Unactioned &&
          el.id !== ActivityStatus.UnactionedNormalRisk,
      );
    }
    return items;
  }, [type]);

  const options: Options = useMemo(
    () =>
      dataSource.map((el) => ({
        value: el.id,
        label: el.name,
        record: el,
      })),
    [dataSource],
  );

  return <BaseSelectBox options={options} {...props} />;
};

export default ActivityStatusSelectBox;
